module.exports = __webpack_public_path__ + "media/images/bg_image/img_bg_image_about_2-05456dda439295c8db219e89dc8e6263.png";